module.exports = __webpack_public_path__ + "static/img/old-driver.b5f1043.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/city-agent/old-driver.png
// module id = elX0
// module chunks = 4